import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



/***
 * Manual imports
 */
import {PagesComponent} from './pages.component';
import {HeaderComponent} from './layout/header/header.component';
import {FooterComponent} from './layout/footer/footer.component';
import {ToolbarModule} from 'primeng/toolbar';
import {ButtonModule} from 'primeng/button';
import {SplitButtonModule} from 'primeng/splitbutton';
import { ModerationModule } from './moderation/moderation.module';
import {ReportingModule} from './reporting/reporting.module';
import { AccueilComponent } from './accueil/accueil.component';
import {AccueilModule} from './accueil/accueil.module';
import { FacturationModule } from './facturation/facturation.module'
import { RetourModule } from './retour/retour.module';
import { HistoriqueModule } from './historique/historique.module';
import { SupervisionModule } from './supervision/supervision.module';
import { AdministrationModule } from './administration/administration.module';
import {SidebarModule} from 'primeng/sidebar';
import {MenuModule} from 'primeng/menu';
import {MenuItem} from 'primeng/api';
import { CqModule } from './cq/cq.module';
import { StatistiqueVolumeTraiterComponent } from './reporting/statistique-volume-traiter/statistique-volume-traiter.component';
import {TableModule} from 'primeng/table';
import { PlaningModule } from './planing/planing.module';
import { ExcelModule } from './excel/excel.module';
import { BrouillonsModule } from './brouillons/brouillons.module';
import { EchantillonageModule } from './echantillonage/echantillonage.module';
import {ReportingClientModule} from './reporting/reporting-client/reporting-client.module';
import { PerformanceModule } from './performance/performance.module';
import { VisualisationComponent } from './visualisation/visualisation.component';
import { VisualisationModule } from './visualisation/visualisation.module';
import { LogsModule } from './logs/logs.module';
import { EnvoiModule } from './envoi/envoi.module';




@NgModule({
  declarations: [HeaderComponent, FooterComponent, PagesComponent, AccueilComponent, StatistiqueVolumeTraiterComponent],
  exports: [
    StatistiqueVolumeTraiterComponent,
  ],
  imports: [
    CommonModule,
    ToolbarModule,
    ButtonModule,
    SplitButtonModule,
    ModerationModule,
    //ReportingModule,
    AccueilModule,
    //FacturationModule,
    RetourModule,
    HistoriqueModule,
    SupervisionModule,
    AdministrationModule,
    SidebarModule,
    MenuModule,
    TableModule,
    PlaningModule,
    CqModule,
    TableModule,
    ExcelModule,
    BrouillonsModule,
    EchantillonageModule,
    ReportingClientModule,
    PerformanceModule,
    VisualisationModule,
    LogsModule,
    EnvoiModule
  ],
})
export class PagesModule { }
